<template>
  <div>
    <el-row :gutter="16" type="flex" align="middle" justify="space-between">
      <el-col :span="4">
        <el-input v-model="crawlerVersion" clearable placeholder="输入采集日期">
        </el-input>
      </el-col>
      <el-col :span="4">
        <el-input v-model="keyword" clearable placeholder="输入检索词">
        </el-input>
      </el-col>
      <el-col :span="4">
        <el-input v-model="redId" clearable placeholder="输入小红书号">
        </el-input>
      </el-col>
      <el-col :span="4">
        <el-input v-model="authorNickname" clearable placeholder="输入用户昵称">
        </el-input>
      </el-col>
      <el-col :span="4">
        <el-input v-model="topicTitle" clearable placeholder="输入标题">
        </el-input>
      </el-col>
      <el-col :span="4">
        <el-select
          v-model="whether"
          clearable
          style="width: 100%"
          placeholder="请选择是否新增"
        >
          <el-option label="非新增" :value="0"></el-option>
          <el-option label="新增" :value="1"></el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row :gutter="16" style="margin-top: 16px" type="flex" justify="center" align="middle">
      <el-col :span="2" :offset="8">
        <el-button icon="el-icon-search" @click="searchPageData"
          >搜索</el-button
        >
      </el-col>
      <el-col :span="2">
        <el-badge v-model="selectedCount" class="item">
          <el-button @click="showSelected" alt="">查看选中</el-button>
        </el-badge>
      </el-col>
      <el-col :span="4">
        <el-button-group>
          <el-button icon="el-icon-delete" @click="clearSelected" alt=""
            >取消选中</el-button
          >
          <el-button icon="el-icon-download" @click="exportSelectedData" alt=""
            >下载</el-button
          >
        </el-button-group>
      </el-col>
      <el-col :span="8"  style="color: #999;font-size: 14px;text-align: right;">
        <p>1、有选中数据时，优先导出选中数据</p>
        <p>2、无选中数据时，导出当前筛选条件下的数据</p>
      </el-col>
      <!-- <el-col :span="2">
        <span>总计: {{ totalItems }}</span>
      </el-col> -->
    </el-row>
    <el-row style="padding-top: 16px">
      <el-pagination
        background
        @current-change="queryGoodsPage"
        layout="total, prev, pager, next"
        :total="totalItems"
        :page-size="pageSize"
      >
      </el-pagination>
    </el-row>
    <el-row style="padding-top: 16px">
      <el-table
        ref="dataTable"
        :data="users"
        style="width: 100%"
        @select="handleSelectionChange"
        @select-all="handleSelectAll"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="searchKeyword" label="日期/关键词">
          <template scope="scope">
            {{ scope.row.crawlerVersion }} / {{ scope.row.searchKeyword }}
          </template>
        </el-table-column>

        <el-table-column prop="_id" label="主键"> </el-table-column>
        <el-table-column label="头像" width="100">
          <template scope="scope">
            <img
              :src="scope.row.authorAvatar"
              width="70"
              height="70"
              class="head_pic"
            />
          </template>
        </el-table-column>
        <el-table-column prop="authorId" label="用户ID"> </el-table-column>
        <el-table-column prop="redId" label="小红书号"> </el-table-column>
        <el-table-column prop="authorNickname" label="用户昵称">
        </el-table-column>
      </el-table>
    </el-row>
  </div>
</template>
<script>
const axios = require("axios");
const _ = require("lodash");
export default {
  name: "redbookPeople",
  data() {
    return {
      users: [],
      keyword: "",
      whether: null,
      redId: "",
      authorNickname: "",
      topicTitle: "",
      crawlerVersion: null,
      currentPage: 1,
      totalItems: 0,
      pageSize: 50,
      selectedCount: 0,
    };
  },
  methods: {
    clearSelected() {
      let _this = this;
      axios
        .get("/api/soci/clear/data?platform=redbook&type=people")
        .then((content) => {
          if (content.data.status.code === "0") {
            _this.selectedCount = 0;
            _this.loadItemInfo(1);
          }
        });
    },
    countSelected() {
      let _this = this;
      axios
        .get("/api/soci/count/data?platform=redbook&type=people")
        .then((content) => {
          if (content.data.status.code === "0") {
            _this.selectedCount = content.data.data;
          }
        });
    },
    showSelected() {
      var _this = this;
      axios.get("/api/redbook/show/selected/people").then((content) => {
        if (content.data.status === 0) {
          _this.users = content.data.data;
          _this.totalItems = content.data.total;
          _this.$nextTick(() => {
            _this.users.forEach((row) => {
              console.log(row);
              if (row.selected === true) {
                _this.$refs.dataTable.toggleRowSelection(row, true);
              }
            });
          });
        }
      });
    },
    exportSelectedData() {
      let para = "";
      if (this.crawlerVersion != null) {
        para += "&crawlerVersion=" + this.crawlerVersion;
      }
      if (this.keyword !== "") {
        para += "&keyword=" + this.keyword;
      }
      if (this.whether !== "") {
        para += "&whether=" + this.whether;
      }
      if (this.redId !== "") {
        para += "&redId=" + this.redId;
      }
      if (this.authorNickname !== "") {
        para += "&authorNickname=" + this.authorNickname;
      }
      if (this.topicTitle !== "") {
        para +=
          "&topicTitle=" +
          encodeURIComponent(this.topicTitle.replace(/(^\s*)|(\s*$)/g, ""));
      }
      if (!this.selectedCount || this.selectedCount === 0) {
        this.$message("导出全部数据需要较长时间，请勿关闭相应窗口。");
        setTimeout(() => {
          window.open("/api/redbook/export/selected/people?" + para);
        }, 1000);
      } else {
        window.open("/api/redbook/export/selected/people?" + para);
      }
      // window.open('/api/redbook/export/selected/people')
    },
    handleSelectAll(selection) {
      let ids =
        selection.length > 0
          ? selection.map((item) => {
              return item._id;
            })
          : this.users.map((item) => {
              return item._id;
            });
      axios
        .post(
          selection.length > 0
            ? "/api/soci/pushToCacheMulti"
            : "/api/soci/removeFromCacheMulti",
          {
            platform: "redbook",
            type: "people",
            ids: ids,
          }
        )
        .then((content) => {
          if (content.data.status === 0) {
            console.log("dfsdfs");
          }
          this.countSelected();
        });

      // this.countSelected();
    },
    handleSelectionChange(selection, row) {
      console.log(selection);
      const existItem = _.find(selection, { _id: row["_id"] });
      if (existItem !== undefined) {
        axios
          .get(
            "/api/soci/pushToCache?platform=redbook&type=people&id=" +
              row["_id"]
          )
          .then((content) => {
            if (content.data.status === 0) {
              console.log("dfsdfs");
            }
            this.countSelected();
          });
      } else {
        axios
          .get(
            "/api/soci/removeFromCache?platform=redbook&type=people&id=" +
              row["_id"]
          )
          .then((content) => {
            if (content.data.status === 0) {
              console.log("dfsdfs");
            }
            this.countSelected();
          });
      }
      // this.countSelected()
    },
    searchPageData() {
      this.currentPage = 1;
      this.loadItemInfo(1);
    },
    queryGoodsPage(pageNum) {
      this.currentPage = pageNum;
      this.loadItemInfo(pageNum);
    },
    loadItemInfo(pageNum) {
      var _this = this;
      let para = "";
      if (this.crawlerVersion != null) {
        para += "&crawlerVersion=" + this.crawlerVersion;
      }
      if (this.keyword !== "") {
        para += "&keyword=" + this.keyword;
      }
      if (this.whether !== "") {
        para += "&whether=" + this.whether;
      }
      if (this.redId !== "") {
        para += "&redId=" + this.redId;
      }
      if (this.authorNickname !== "") {
        para += "&authorNickname=" + this.authorNickname;
      }
      if (this.topicTitle !== "") {
        para +=
          "&topicTitle=" +
          encodeURIComponent(this.topicTitle.replace(/(^\s*)|(\s*$)/g, ""));
      }
      axios
        .get(
          "/api/redbook/people?currentPage=" + pageNum + "&pageSize=50" + para
        )
        .then((content) => {
          if (content.data.status === 0) {
            _this.users = content.data.data;
            _this.totalItems = content.data.total;
            _this.$nextTick(() => {
              _this.users.forEach((row) => {
                console.log(row);
                if (row.selected === true) {
                  _this.$refs.dataTable.toggleRowSelection(row, true);
                }
              });
            });
          }
        });
    },
  },
  mounted() {
    this.loadItemInfo(1);
    this.countSelected();
  },
};
</script>
